import {
  ADD_NOTIFICATION,
  SET_NOTIFICATIONS,
  UPDATE_NOTIFICATION,
} from '../actionTypes';
import {INotification} from 'constants/interfaces';

export type NotificationsState = {notifications: INotification[]};
const initialState: NotificationsState = {notifications: []};

export default function (
  state = initialState,
  action: {type: string; payload: any},
) {
  switch (action.type) {
    case SET_NOTIFICATIONS: {
      const notifications: INotification[] = action.payload || [];
      const stateUpdate: NotificationsState = {
        notifications: notifications.map((notification) => ({...notification})),
      };
      return stateUpdate;
    }

    case UPDATE_NOTIFICATION: {
      const notificationUpdate: INotification = action.payload;
      if (!notificationUpdate) return state;

      const stateUpdate: NotificationsState = {
        notifications: state.notifications.map((notification) => {
          if (notification.id === notificationUpdate.id)
            return {...notificationUpdate};
          return notification;
        }),
      };
      return stateUpdate;
    }

    case ADD_NOTIFICATION: {
      const notificationUpdate: INotification = action.payload;
      if (!notificationUpdate) return state;

      const exists = state.notifications.find(
        (notification: INotification) =>
          notification.id === notificationUpdate.id,
      );
      if (exists) return state;

      const stateUpdate: NotificationsState = {
        notifications: [
          notificationUpdate,
          ...state.notifications.map((notification) => ({
            ...notification,
          })),
        ],
      };
      return stateUpdate;
    }

    default:
      return state;
  }
}
